<template>
  <div id="app">
    <p
        v-if="this.app.isBeta"
        class="alert alert-info alert-beta text-center"
        style="border-radius: 0"
    >
      Beta versie - <router-link to="/about">meer info</router-link>
    </p>
    <network-status-bar/>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import NetworkStatusBar from '@/components/Network-Status-Bar'

export default {
  name: 'app',
  components: {
    NetworkStatusBar,
  },
  watch: {
    '$route'() {
      this.closeMainNavbarIfNeeded()
    }
  },
  computed: {
    useBeta () {
      return this.$store.getters.useBeta
    },
    selectedEstablishment () {
      return this.$store.getters.selectedEstablishment
    },
    selectedGroup () {
      return this.$store.getters.selectedGroup
    },
    selectedGroups () {
      return this.$store.getters.selectedGroups
    }
  },
  data () {
    return {
      error: null
    }
  },
  created () {
    if (this.app.isBeta === true && this.useBeta === false) {
      this.switchToStable()
    } else if (this.app.isBeta === false && this.useBeta === true) {
      this.switchToBeta()
    }

    var app = this
    this.resetStateIfNeeded(function () {
      app.$router.push('/')
      location.reload()
    }, function () {
      var sessionToken = null
      if (app.session !== null && app.session.session_token) {
        sessionToken = app.session.session_token
      }
      window.novict = {
        apiBaseUrl: process.env.VUE_APP_API_URL,
        device: {
          device_token: app.deviceToken
        },
        session: {
          session_token: sessionToken
        }
      }
      const today = app.$moment().format('YYYY-MM-DD')
      app.$store.commit('SET_SHOW_MAIN_NAVBAR', true)
      app.$store.commit('SET_SHOW_SIDE_NAVBAR', false)
      app.$store.commit('SET_SHOW_SEARCH', false)
      app.$store.commit('SET_SHOW_GLOBAL_CHILD_FILTER', false)
      app.$store.commit('RESET_ACTIVE_REQUEST_COUNT')
      if (app.selectedGroups) {
        app.$store.dispatch('getChildren')
        app.$store.dispatch('getGroups')
        app.$store.dispatch('getChildrenPresence')
        app.$store.dispatch('getBirthdays')
        app.$store.dispatch('getGroupInstructions')
        app.$store.dispatch('getGroupActivities')
        app.$store.dispatch('getTransferNotes', {date: today})
        app.$store.dispatch('getPlanning', today)
      }
      // show main navbar?
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (screenWidth > 577) {
        app.$store.commit('SET_SHOW_MAIN_NAVBAR', true)
      } else {
        app.$store.commit('SET_SHOW_MAIN_NAVBAR', false)
      }
    })
  }
}
</script>

<style>

/*
    Reboot
*/
html {
    min-height: 100%;
    position: relative;
}

body {
    height: 100%;
    background: #f8f9fa;
    color: #666;
}

a {
    text-decoration: none;
}

label:not(.form-check-label, .col-form-label, .form-label) {
  margin-top: 10px;
}

.scrollable {
  overflow-y: scroll;
}
.bg-dark {
  background-color: #505761 !important;
}
.btn {
  border-radius: 10px;
}
.btn-info {
  background-color: #5bc0de;
  border-color: #46b8da;
  color: #fff;
}
.btn-info:hover {
  background-color: #31b0d5;
  border-color: #269abc;
  color: #fff;
}
.btn-outline-info {
    border-color: #5bc0de;
    color: #5bc0de;
}
.btn-outline-info:hover {
    background-color: #5bc0de;
    border-color: #5bc0de;
    color: #fff;
}
.btn-secondary {
    background-color: #868e96;
    border-color: #868e96;
    color: #fff;
}
.btn-secondary:hover {
    background-color: #5a6268;
    border-color: #5a6268;
}
#planning-child-ratio .modal-body {
  padding: 0;
}
/* calendar dialog */
#calendarDialog {
  color: #555555;
}
.planning-item-times {
  font-size: 18px;
}
.planning-item-type {
  font-size: 12px;
}
.type-color-schedule {
  color: #7EA6E0;
}
.type-color-extra-day {
  color: #FFB570;
}
.type-color-exchange {
  color: #97D077;
}
.planning-item-control {
  font-size: 20px;
}
.planning-item-control:hover {
  cursor: pointer;
  color: #000000;
}
.planning-item-undo-exchange-action:after {
  color: #FFB570;
}
.planning-item-charged {
  color: #97D077;
}
.planning-item-charged:hover {
  cursor: not-allowed;
  color: #97D077;
}
#addition-box {
  margin-top: 10px;
  padding-bottom: 50px;
}
#exchange-hours-amount{
  font-weight: bold;
}
.plan-options {
  margin-left: -80px;
}
#exchange-range-text {
  font-size: 11px;
}
.fb a {
  color: blue !important;
}
.modal-backdrop {
  opacity:1.0 !important;
  background: #2479bc;
}
#calendarDialog,
.ui-dialog .ui-dialog-content {
  overflow: initial !important;
}
.ui-widget {
  padding: 0;
}
.ui-widget-header,
.ui-dialog-buttonpane {
  background: white !important;
  background-color: white !important;
  border: 0 !important;
}
.ui-widget-header {
  border-bottom: 1px solid #e5e5e5;
  padding-top: 10px;
  padding-bottom: 10px;
}
.ui-dialog-buttonpane {
  border-top: 1px solid #e5e5e5;
}
.ui-widget,
.ui-widget-content {
  background: #efeff4;
  padding: 0;
}
.ui-widget .btn {
  margin: 0 !important;
}
.ui-dialog .ui-dialog-title {
  padding-top: 4px;
  padding-bottom: 5px;
  padding-left: 15px;
  font-size: 20px;
  font-weight: normal;
  color: #aeaeae;
}

.ui-widget-overlay {
  opacity: 1 !important;
  background: #2479bc !important;
}

/* verberg sluit kruisje in de hoek */
.ui-dialog-titlebar-close {
  visibility: hidden;
}

.ui-dialog-buttonset {
  text-align: left;
}

/* button */
.ui-state-default {
  background-color: #fbfbfb !important;
  border-color: #269abc !important;
}
.ui-state-default,
.ui-state-default:hover {
  color: #5bc0de !important;
  background: white !important;
  background-color: white !important;
  border-color: #5bc0de !important;
}
.ui-state-default,
.ui-state-default:hover,
.ui-state-default:focus,
.ui-state-default:active,
.ui-state-default.active,
.open .dropdown-toggle..ui-state-default {
  color: #5bc0de !important;
  background-color: #ebebeb !important;
  border-color: #adadad !important;
}
.ui-button:hover,
.ui-button:focus {
  color: #333;
  text-decoration: none;
}
.ui-button {
  line-height: 16px;
  font-size: 13px;
}
.ui-button {
  -moz-border-radius: 18px;
  border-radius: 18px;
  padding: 3px;
  font-size: 12px;
  line-height: 12px;
  font-weight: bold;
  margin: 5px;
}

.group-thumbnail {
  margin-right: 5px;
  display: flex;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  color: #fff;
  font-size: 9px;
  line-height: 8px;
  text-align: center;
  background-color: #bcc6d3;
  justify-content: center;
  align-items: center;
}
.no-children {
  padding: 25px;
}
.text-right {
    text-align: right;
}

[class^="col"]:has(.status-box):not(:has([class^="col"] .status-box))  {
    padding-right: 10px;
}

</style>
